import React from 'react'
import PropTypes from 'prop-types'
import {
  Modal, Icon, Header,
} from 'semantic-ui-react'
import { translate } from 'react-i18next'

import UserActivityChart from '../../charts/user-activity'

import './user-activity-thumb.css'

const TRANSLATION_PREFIX = 'common.user-activity-thumb'

class UserActivityThumb extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      isOpen: false,
    }
  }

  static propTypes = {
    isLoading: PropTypes.bool,
    rolesWithActivityByRoleType: PropTypes.object,
    t: PropTypes.func,
  }

  static defaultProps = {
    isLoading: true,
    t: (key, opts = {}) => opts.defaultValue || key,
  }

  showModal = () => {
    this.setState({ isOpen: true })
  }

  hideModal = () => {
    this.setState({ isOpen: false })
  }

  render () {
    const {
      isLoading,
      rolesWithActivityByRoleType,
      t,
    } = this.props
    return (
      <React.Fragment>
        <Header
          as='h4'
          className='user-activity-chart-icon'
          icon
          textAlign='center'
          onClick={this.showModal}
        >
          <Icon name='chart line' />
          {t(`${TRANSLATION_PREFIX}.label`)}
        </Header>

        <Modal
          className='messageModal'
          open={this.state.isOpen}
          closeOnEscape={true}
          closeOnDimmerClick={true}
          onClose={this.hideModal}
          size='large'
        >
          <Modal.Header><Icon size='large' name='chart line'></Icon> {t(`${TRANSLATION_PREFIX}.label`)}</Modal.Header>
          <Modal.Content scrolling>
            <UserActivityChart
              isLoading={isLoading}
              rolesWithActivityByRoleType={rolesWithActivityByRoleType}
            />
          </Modal.Content>
        </Modal>
      </React.Fragment>
    )
  }
}

export default translate([ 'components' ])(UserActivityThumb)
